import { Form, HttpService, Input, LookUpDropDown } from 'library';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IFormData, IFormState, SystemFormDetail } from '../../../library/form/SystemFormDetail';
interface IDrugType extends IFormData {
    GlobalizationId?: number,
    EnglishText: string,
    TranslatedText?: string,
    Language?: string,
    RowVersion?: string
}

class SystemLanguageForm extends SystemFormDetail<IDrugType, any, any>{
    constructor(props: any) {
        super(props);

    }

    initial = (): IFormState<IDrugType> => {
        return {
            formData: {
                PrimaryKeyEncrypted: (this.props.data && this.props.data.PrimaryKeyEncrypted) ? this.props.data.PrimaryKeyEncrypted : '',
                GlobalizationId: undefined,
                Language: '',
                EnglishText: localStorage.getItem("LableName")||'',
                TranslatedText:''
            }
        }
    }


    prepare = () => {
        return {
            ...this.state.formData,
            GlobalizationId: this.state.formData.GlobalizationId,
            Language: this.state.formData.Language,
            EnglishText: this.state.formData.EnglishText,
            TranslatedText: this.state.formData.TranslatedText,
        }
    }

    load = (data: any) => {
        if (data) {
            this.setState({
                formData: {
                    ...data,
                     GlobalizationId: data.GlobalizationId,
                    Language: data.DataValue,
                    EnglishText: data.EnglishText,
                    TranslatedText: data.TranslatedText, 
                }
            })
        }
    }
   



    componentDidUpdate = (prevProps: any) => {
        if (this.props.data && prevProps.data.PrimaryKeyEncrypted != this.props.data.PrimaryKeyEncrypted) {
            this.setState({ formData: { ... this.state.formData, PrimaryKeyEncrypted: this.props.data.PrimaryKeyEncrypted } });
        }
    }

    handleChange = (event: any, name: string, value: any) => {
        this.setState({ formData: { ...this.state.formData, [name]: value } });
        if (this.props.onChange) this.props.onChange(name, value);
    }

    onDelete = () => {
        this.props.onDelete && this.props.onDelete();
    }


    validateAsync = async () => {
        var flag = true;

        
        var GlobalizationMapping = await HttpService.get(`Common/IsGlobalizationExists/${this.state.formData.EnglishText}/${this.state.formData.Language}`).then(res => res.data)
        console.log("GlobalizationMapping", GlobalizationMapping)
        if (GlobalizationMapping === true) {
                toast.info("This translation already exists!")
                flag = false;
                return false
            
        }
        return flag && this.validate();
    }

    render() {
        const url = '/Common/Globalization'
        console.log(this.state.formData)
        return (<>
            <Form label="System Language"
                url={url}
                securityObject="System.Globalization"
                schema="Security" table="Globalization"
                primaryKeyEncrypted={this.state.formData.PrimaryKeyEncrypted}
                onInitialize={this.initialize}
                onClear={this.initialize}
                onLoad={this.load}
                onValidate={this.validate}
                onValidateAsync={this.validateAsync}
                onPrepare={this.prepare}
                onRecordUpdated={this.props.onRecordUpdated}
                onAfterDelete={this.onDelete}
                canDelete={true}
                showSave={true}
                canReview={false}
            >
                {/*<div className="col-md-6">

                    <DropDown
                        id="LookupTypeId" name="LookupTypeId" label='Lookup Type'
                        isRequired={true}
                        displayField="LookupTypeName" idField="LookupTypeId" dataSource="LookupType/list"
                        validator={this.validator} componentClass="col-sm-7"
                        labelClass="col-sm-5"
                        onChange={this.handleChange} value={this.state.formData.LookupTypeId}
                        disabled={true} />


                </div> <div className="col-md-6"> </div>*/}

                {/*<div className="col-md-6">*/}
                {/*    <Input*/}
                {/*        isRequired={true}*/}
                {/*        label='Data Text'*/}
                {/*        componentClass="col-sm-7"*/}
                {/*        labelClass="col-sm-5"*/}
                {/*        defaultValue={this.state.formData.DataText}*/}
                {/*        name="DataText"*/}
                {/*        validator={this.validator}*/}
                {/*        minLength={1}*/}
                {/*        maxLength={255}*/}
                {/*        id="DataText"*/}
                {/*        onChange={this.handleChange}*/}
                {/*        value={this.state.formData.DataText}*/}
                {/*        disabled={this.state.formData.PrimaryKeyEncrypted && this.state.formData.IsEditable == false ? true : false} />*/}
                {/*</div>*/}
                {/*<div className="col-md-6">*/}
                {/*    <Input*/}
                {/*        isRequired={true}*/}
                {/*        label='Data Value'*/}
                {/*        componentClass="col-sm-7"*/}
                {/*        validator={this.validator}*/}
                {/*        labelClass="col-sm-5"*/}
                {/*        defaultValue={this.state.formData.DataValue}*/}
                {/*        name="DataValue"*/}
                {/*        id="DataValue"*/}
                {/*        minLength={1}*/}
                {/*        maxLength={255}*/}
                {/*        onChange={this.handleChange}*/}
                {/*        value={this.state.formData.DataValue}*/}
                {/*        disabled={this.state.formData.PrimaryKeyEncrypted && this.state.formData.IsEditable == false ? true : false} />*/}
                {/*</div>*/}
                {/*<div className="col-md-6">*/}
                {/*    <NumberInput id='Ordinal' componentClass="col-sm-7"*/}
                {/*        labelClass="col-sm-5" name='Ordinal' label='Ordinal' validator={this.validator} onChange={this.handleChange}*/}
                {/*        isRequired={true} minValue={1} maxValue={65000}*/}
                {/*        value={this.state.formData.Ordinal}*/}
                {/*        disabled={this.state.formData.PrimaryKeyEncrypted && this.state.formData.IsEditable == false ? true : false} />*/}

                {/*</div>*/}
                <div className="col-md-12">
                    <LookUpDropDown
                        id="Language"
                        name="Language"
                        label='Language'
                        isRequired={true}
                        componentClass="col-sm-9"
                        labelClass="col-sm-3"
                        lookupName="Lookup-PreferredLanguage"
                        validator={this.validator}
                        onChange={this.handleChange}
                        value={this.state.formData.Language}
                        disabled={this.state.formData.IsAutomated} />
                </div>
                <div className="col-md-12">
                <Input
                        isRequired={true}
                        label='Translated Text'
                        componentClass="col-sm-9"
                        labelClass="col-sm-3"
                        defaultValue={this.state.formData.TranslatedText}
                        name="TranslatedText"
                        id="TranslatedText"
                        validator={this.validator}
                        onChange={this.handleChange}
                        value={this.state.formData.TranslatedText}
                        disabled={false} />
                </div>
                {/*<div className="col-md-6">
                {/*    <Input*/}
                {/*        isRequired={true}*/}
                {/*        label='LookUp Parent Id'*/}
                {/*        componentClass="col-sm-7"*/}
                {/*        validator={this.validator}*/}
                {/*        labelClass="col-sm-5"*/}
                {/*        defaultValue={this.state.formData.LookUpParentId}*/}
                {/*        name="LookUpParentId"*/}
                {/*        id="LookUpParentId"*/}
                {/*        minLength={1}*/}
                {/*        maxLength={255}*/}
                {/*        onChange={this.handleChange}*/}
                {/*        value={this.state.formData.LookUpParentId}*/}
                {/*        disabled={this.state.formData.LookUpParentId && this.state.formData.IsEditable == false ? true : false} />*/}
                {/*</div>*/}
                {/*<Input*/}
                {/*    isRequired={true}*/}
                {/*    label='Language'*/}
                {/*    componentClass="col-sm-7"*/}
                {/*    labelClass="col-sm-5"*/}
                {/*    name="Language"*/}
                {/*    id="Language"*/}
                {/*    onChange={this.handleChange}*/}
                {/*    validator={this.validator}*/}
                {/*    value={this.state.formData.LookupName}*/}
                {/*    disabled={false} />*/}

                {/*<div className="col-md-6">*/}

                {/*    <Input*/}
                {/*        isRequired={true}*/}
                {/*        label='Arabic Data Value'*/}
                {/*        componentClass="col-sm-7"*/}
                {/*        labelClass="col-sm-5"*/}
                {/*        defaultValue={this.state.formData.LookupDescription}*/}
                {/*        name="ArabicDataValue"*/}
                {/*        id="ArabicDataValue"*/}
                {/*        validator={this.validator}*/}
                {/*        onChange={this.handleChange}*/}
                {/*        value={this.state.formData.LookupDescription}*/}
                {/*        disabled={false} />*/}

                {/*</div>*/}
                {/*<div className="col-md-6">
                    <Switch
                        label='Active'
                        isRequired={false}
                        onChange={this.handleChange}
                        name='Active'
                        id='Active'
                        componentClass="col-sm-7"
                        labelClass="col-sm-5"
                        defaultValue={this.state.formData.Active}
                        value={this.state.formData.Active}
                        disabled={this.state.formData.PrimaryKeyEncrypted && this.state.formData.IsEditable == false ? true : false} />

                </div>*/}{/* <div className="col-md-6">
                    <Switch
                        label='Editable'
                        isRequired={false}
                        onChange={this.handleChange}
                        name='IsEditable'
                        id='IsEditable'
                        componentClass="col-sm-7"
                        labelClass="col-sm-5"
                        defaultValue={this.state.formData.IsEditable}
                        value={this.state.formData.IsEditable}
                        disabled={this.state.formData.PrimaryKeyEncrypted && this.state.formData.IsEditable == false ? true : false} />

                </div>*/}
            </Form>
        </>)
    }
};
export default  SystemLanguageForm;